import { Avatar, Button, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "../../store/Central";

export const ProfilePage = () => {
	const { profile, signOut, avatarUrl } = useCentralStore.getState();
	if (!profile) return;
	const navigate = useNavigate();
	
	const name = `${profile?.title ?? ""} ${profile?.first_name} ${
		profile?.last_name
	}`;
	return (
		<div>
			<div className="font-bold text-xl mb-4">Kontoeinstellungen</div>
			<div className=" flex justify-center w-full h-32 overflow-hidden p-1">
				<Avatar
					sx={{
						width: 96,
						height: 96,
					}}
					alt="avatar"
					src={avatarUrl}
				/>
			</div>
			<form className="gap-4 flex flex-col w-full">
				<TextField
					disabled
					value={name || ""}
					label="Namen"
					name="full_name"
					size="small"
				/>
				<TextField
					disabled
					value={profile.display_name || ""}
					label="Benutzername"
					name="display_name"
					size="small"
				/>
				<TextField
					disabled
					value={profile.additional_information || ""}
					name="additional_information"
					label="Zusatz"
					size="small"
				/>
				<TextField
					disabled
					value={profile.street || ""}
					name="street"
					label="Strasse"
					size="small"
				/>
				<TextField
					disabled
					value={profile.city || ""}
					name="city"
					label="Stadt"
					size="small"
				/>
				<TextField
					disabled
					value={profile.phone_personal || ""}
					name="phone_personal"
					label="Telefon (privat)"
					size="small"
				/>
				<TextField
					value={profile.phone_mobile || ""}
					name="phone_mobile"
					label="Telefon (mobil)"
					disabled
					size="small"
				/>
				<Button
					onClick={async () => {
						await signOut();
						navigate("/login");
					}}
				>
					Ausloggen
				</Button>
			</form>
		</div>
	);
};
